import { useState } from 'react';
import { useCompanyStore } from '../stores/company';

// Local mock store for chain-of-custody
const LS_KEY = 'evat:custody';
function load(){ try{ const r = localStorage.getItem(LS_KEY); return r? JSON.parse(r) as Record<string, any[]>: {}; }catch{ return {}; } }
function save(db: Record<string, any[]>) { try{ localStorage.setItem(LS_KEY, JSON.stringify(db)); }catch{} }
function exportEvidenceTrail(companyId:string){ const db = load(); return db[companyId] || []; }
function appendEvidence(companyId:string, docHash:string, actor:string){ const db = load(); db[companyId] = db[companyId] || []; db[companyId].push({ timestamp:new Date().toISOString(), docHash, actor }); save(db); }

export function ChainOfCustody() {
  const company = useCompanyStore((s)=> s.companies.find(c=>c.id===s.activeId) ?? null);
  const [hash, setHash] = useState('0xabc');
  const [rows, setRows] = useState(company? exportEvidenceTrail(company.id): []);
  const add = () => { if (!company) return; appendEvidence(company.id, hash, 'user'); setRows(exportEvidenceTrail(company.id)); };
  return (
    <div className="space-y-2">
      <div className="font-orbitron text-evat-gold">Chain of Custody</div>
      <div className="flex gap-2 text-sm">
        <input value={hash} onChange={(e)=>setHash(e.target.value)} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 w-full" placeholder="doc hash"/>
        <button onClick={add} className="px-3 py-1 rounded border border-evat-neon text-evat-neon">Append</button>
      </div>
      <div className="border border-neutral-700 rounded p-2 text-xs max-h-64 overflow-auto">
        {rows.map((r,i)=> (<div key={i} className="mb-1">{r.timestamp} • {r.actor} • <span className="break-all">{r.docHash}</span></div>))}
        {rows.length===0 && <div className="text-neutral-500">No entries</div>}
      </div>
    </div>
  );
}

export default ChainOfCustody;



